import { TypePolicies } from '@apollo/client'

export const bankingTypePolicies: TypePolicies = {
  FinanceInvoice: {
    fields: {
      reconciliations: {
        merge(_existing: unknown, incoming: unknown) {
          return incoming
        },
      },
    },
  },
  BankingTransaction: {
    fields: {
      reconciliationSuggestions: {
        merge(_existing: unknown, incoming: unknown) {
          return incoming
        },
      },
    },
  },
}
